<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent">This book is dedicated to my brother Jay, who (as Jack C. Haldeman II) wrote eight science fiction novels and over a hundred short stories—and also dedicated to. Alaska, where we had the good fortune to live as children.</p>
<p class="indent">The state is calling itself “our last, best hope” now, which may or may not be true. It is probably the best place to raise a child if for some reason you want him or her to become a science fiction writer. The beauty and size of it, the limitless possibilities. The amazing sky.</p>
<p class="spb">I also want to thank the Clutes, John and Judith. John, for clueing me in on the Flammarion novel that eerily parallels this one; Judith, for leading me on a wild bicycle ride through the labyrinthine streets of London, to their huge book collection, where we actually found an English translation of it.</p>
<p class="spb">One character’s name was changed to memorialize Gordon R. Dickson, who took many of us to places we wouldn’t have found on our own.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6a2f208a